import { render, staticRenderFns } from "./CardTestimonial.vue?vue&type=template&id=035e9d3e&"
import script from "./CardTestimonial.vue?vue&type=script&lang=js&"
export * from "./CardTestimonial.vue?vue&type=script&lang=js&"
import style0 from "./CardTestimonial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports